// Types
import { ErrorAccordionComponentType } from '../types/error-accordion.type';

const isErrorTypeError = (error: ErrorAccordionComponentType['error']): boolean =>
  error instanceof TypeError || typeof error === 'object';

const mapShowErrorAccordingType = (error: ErrorAccordionComponentType['error']): string =>
  isErrorTypeError(error) ? error.toString() : (error as string);

export { mapShowErrorAccordingType };
